import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {BaseComponent} from './base/base.component';
import {InitialDataResolver} from './app.resolver';

let routes: Routes = [];

routes = [
  {
    path: 'popups',
    resolve: {
      initialData: InitialDataResolver,
    },
    loadChildren: () => import('./popups/popups.module').then(m => m.PopupsModule)
  },
  {
    resolve: {
      initialData: InitialDataResolver,
    },
    path: '',
    component: BaseComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'artists',
        loadChildren: () => import('./pages/artists/artists.module').then(m => m.ArtistsModule)
      },
      {
        path: 'cooperations',
        loadChildren: () => import('./pages/cooperations/cooperations.module').then(m => m.CooperationsModule)
      },
      {
        path: 'events',
        loadChildren: () => import('./pages/events/events.module').then(m => m.EventsModule)
      },
      {
        path: 'companies',
        loadChildren: () => import('./pages/companies/companies.module').then(m => m.CompaniesModule)
      },
      {
        path: 'acquisitions',
        loadChildren: () => import('./pages/acquisitions/acquisitions.module').then(m => m.AcquisitionsModule)
      },
      {
        path: 'contacts',
        loadChildren: () => import('./pages/contacts/contacts.module').then(m => m.ContactsModule)
      },
      {
        path: 'messages',
        loadChildren: () => import('./pages/messages/messages.module').then(m => m.MessagesModule)
      },
      {
        path: 'statistics',
        loadChildren: () => import('./pages/statistics/statistics.module').then(m => m.StatisticsModule)
      },
      {
        path: 'revenues',
        loadChildren: () => import('./pages/revenues/revenues.module').then(m => m.RevenuesModule)
      },
      {
        path: 'doings',
        loadChildren: () => import('./pages/doings/doings.module').then(m => m.DoingsModule)
      },
      {
        path: 'invoices',
        data: { },
        loadChildren: () => import('./pages/invoices/invoices.module').then(m => m.InvoicesModule)
      },
      {
        path: 'client-invoices',
        data: { mitm: false },
        loadChildren: () => import('./pages/invoices/invoices.module').then(m => m.InvoicesModule)
      },
      {
        path: 'own-invoices',
        data: { mitm: true },
        loadChildren: () => import('./pages/invoices/invoices.module').then(m => m.InvoicesModule)
      },
      {
        path: 'commission-invoices',
        data: { commission: true },
        loadChildren: () => import('./pages/invoices/invoices.module').then(m => m.InvoicesModule)
      },
      {
        path: 'credit-invoices',
        data: { credit: true },
        loadChildren: () => import('./pages/invoices/invoices.module').then(m => m.InvoicesModule)
      },
      {
        path: 'duns',
        loadChildren: () => import('./pages/duns/duns.module').then(m => m.DunsModule)
      },
      {
        path: 'settlements',
        loadChildren: () => import('./pages/settlements/settlements.module').then(m => m.SettlementsModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule)
      },
      {
        path: 'users',
        loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule)
      },
      {
        path: 'billing-cycles',
        loadChildren: () => import('./pages/billing-cycles/billing-cycles.module').then(m => m.BillingCyclesModule)
      },
      {
        path: 'media',
        loadChildren: () => import('./pages/platform-media/platform-media.module').then(m => m.PlatformMediaModule)
      },
      {
        path: 'calendar',
        loadChildren: () => import('./pages/calendar/calendar.module').then(m => m.CalendarModule)
      },
    ],
  },
  {
    path: 'oauth',
    loadChildren: () => import('./pages/oauth/oauth.module').then(m => m.OauthModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
